import React from 'react';
import type { TableColumnsType } from 'antd';
import { Table, Tag } from 'antd';
import { AccountTransactionFlowType } from '../graphql/types/AccountTransactionFlowType';

interface AccountTransactionFlowRowProps {
    rowData: AccountTransactionFlowType[];
    loading?: boolean;
}

// 资金流向颜色映射
const directionColorMap: Record<string, { color: string; label: string }> = {
    '收入': { color: 'green', label: '收入' },
    '支出': { color: 'red', label: '支出' },
    '冻结': { color: 'orange', label: '冻结' },
    '解冻': { color: 'blue', label: '解冻' },
};

export const AccountTransactionFlowColumns: React.FC<AccountTransactionFlowRowProps> = ({
    rowData,
    loading
}) => {

    const accountTransactionFlowColumns: TableColumnsType<AccountTransactionFlowType> = [
        {
            title: '客户名称',
            dataIndex: 'clientName',
            key: 'clientName',
            align: 'center',
        },
        {
            title: '客户ID',
            dataIndex: 'clientId',
            key: 'clientId',
            align: 'center',
        },
        {
            title: '账户ID',
            dataIndex: 'virtualAccountId',
            key: 'virtualAccountId',
            align: 'center',
        },
        {
            title: '流水ID',
            dataIndex: 'flowNo',
            key: 'flowNo',
            align: 'center',
        },
        {
            title: '资金流向',
            dataIndex: 'direction',
            key: 'direction',
            align: 'center',
            render: (direction) => {
                const config = directionColorMap[direction];
                if (config) {
                    return <Tag color={config.color}>{config.label}</Tag>;
                }
                return <Tag>{direction}</Tag>;
            },
        },
        {
            title: '金额',
            key: 'transactionAmount',
            align: 'center',
            render: (_, record) => {
                const isIncome = record.direction === '收入';
                const isExpense = record.direction === '支出';
                const amount = record.transactionAmount || '0.00';
                
                if (isIncome) {
                    return <span style={{ color: '#52c41a', fontWeight: 500 }}>${amount}</span>;
                }
                if (isExpense) {
                    return <span style={{ color: '#ff4d4f', fontWeight: 500 }}>${amount}</span>;
                }
                return <span>${amount}</span>;
            },
        },
        {
            title: '关联交易单号',
            dataIndex: 'associatedTransactionNo',
            key: 'associatedTransactionNo',
            align: 'center',
        },
        {
            title: '交易时间',
            dataIndex: 'transactionTime',
            key: 'transactionTime',
            align: 'center',
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            align: 'center',
        }
    ];

    return (
        <Table
            rowKey={(record) => record.id}
            columns={accountTransactionFlowColumns}
            dataSource={rowData}
            scroll={{ x: 1950 }}
            size="middle"
            className="mb-4"
            pagination={false}
            loading={loading}
        />
    );
};
